import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "chevron"]
  static values = { open: { type: Boolean, default: true } }

  connect() {
    this.updateState()
  }

  toggle() {
    this.openValue = !this.openValue
    this.updateState()
  }

  updateState() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle('hidden', !this.openValue)
    }
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle('rotate-180', !this.openValue)
    }
  }
}
